import { TemplateVersionNameCell } from './TemplateVersionNameCell'

type Props = {
  column: number
}

export const TemplateVersionCell = ({ column }: Props) =>
  column === 0 ? <TemplateVersionNameCell /> : null
